import React from "react";
import { Plan } from "../../../@types";
import { isCurrentPlan } from "../../../helpers";
import { AppStore } from "../../../app/store";
import { FormattedMessage } from "react-intl-phraseapp";

export const CurrentPlan: React.FunctionComponent<{ plan: Plan }> = ({
  plan,
}) => {
  const {
    state: { currentCoverage },
  } = React.useContext(AppStore.AppContext);
  const currentPlan = isCurrentPlan(currentCoverage, plan);

  return currentPlan ? (
    <div className="ds-u-font-weight--bold">
      <FormattedMessage id="plan_card.your_current_plan" />
    </div>
  ) : null;
};
